<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_3"><img alt="Image" src="images/f0003-01.jpg"/><br/>* the toddler café *</a></h1><a id="page_3">
<p class="subtitle"><em>fast, healthy, and fun ways to feed even the pickiest eater</em></p>
<p class="author"><strong>by</strong> jennifer carden <strong>* hotographs by</strong> matthew carden</p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?19f587eb